<template>
  <div>
    <v-toolbar dark :src="require('@/assets/core/alleenlijn.jpg')">
      <v-toolbar-title class="ml-15">Trusted Accountant</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggle_dark_mode">
        <v-icon>mdi-theme-light-dark</v-icon>
      </v-btn>
<!--      <v-col ma-6 lg="2" md="3" sm="4" cols="5">-->
<!--        <v-select-->
<!--          v-model="$i18n.locale"-->
<!--          :items="items"-->
<!--          item-text="lang"-->
<!--          item-value="abbr"-->
<!--          label="Select"-->
<!--          single-line-->
<!--          class="fit"-->
<!--        ></v-select>-->
<!--      </v-col>-->
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: "Toolbar",
  data() {
    return {
      theme: null,
      items: [
        { lang: "english", abbr: "en" },
        { lang: "nederlands", abbr: "nl" },
      ],
    };
  },
  methods: {
    toggle_dark_mode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      this.$vuetify.theme.dark = theme === "true";
    }
  },
};
</script>
<style scoped></style>
